module.exports = __webpack_public_path__ + "static/HUB3-f4a042cd01e540d44d0da7376356bc8a.png";